import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import { cx } from 'ramda-extension';

export const CardDropField = ({ animate = false, dropFieldText = '' }) => (
	<Box
		className={cx(['CardMain', 'CardMain--dropField'], {
			'CardMain--dropFieldOnDrag': animate,
		})}
		sx={{
			border: (theme) => `3px solid ${theme.palette.background[300]}`,
		}}
	>
		<div className="CardMain-dragDrop CardMain-dragDrop--gray" />
		<Box
			sx={{
				whiteSpace: 'nowrap',
				overflow: 'hidden !important',
				textOverflow: 'ellipsis',
				fontSize: '20px',
				margin: 'auto',
				fontWeight: 'bold',
				color: 'background.300',
			}}
		>
			{dropFieldText}
		</Box>
	</Box>
);

CardDropField.propTypes = {
	animate: PropTypes.bool,
	dropFieldText: PropTypes.string,
};

export default CardDropField;
